import { render, staticRenderFns } from "./stuTree.vue?vue&type=template&id=4c0ac367&scoped=true"
import script from "./stuTree.vue?vue&type=script&lang=js"
export * from "./stuTree.vue?vue&type=script&lang=js"
import style0 from "./stuTree.vue?vue&type=style&index=0&id=4c0ac367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ac367",
  null
  
)

export default component.exports